import React from 'react';

declare var InovxLoader: any;

export interface ConfigurationActionsProps {
    onAddSchema: () => void;
}

const ConfigurationActions: React.FC<ConfigurationActionsProps> = ({ onAddSchema }) => {
    return (
        <div className="configuration-form-panel-header">
            <button type="button" className="configuration-form-add-primary-btn plus-btn" onClick={onAddSchema} title={InovxLoader.t('facility:form.addPrimarySchema')}>
                <span className="plus-btn-icon"><i className="fa fa-plus" /></span> <div className="configuration-form-panel-title">{InovxLoader.t('facility:form.addPrimarySchema')}</div>
            </button>
        </div>
    );
};

export default ConfigurationActions;